import React, { useRef } from 'react'
import { useLoad } from '../hooks/load'
import { sanitizeIconSVG } from '../svg/sanitize-svg'
import { IconProvider } from '../icon/icon'

// One sanitised SVG, assigned to innerHTML the way the sign-in page's
// provider buttons render it (login-provider.js).
export const IconSVG = ({ svg, className }) => {
  const ref = useRef(null)
  const clean = svg ? sanitizeIconSVG(svg) : ''
  useLoad(() => { if (ref.current) ref.current.innerHTML = clean }, [clean])
  return clean ? <span ref={ref} className={className} /> : null
}

// The provider logo tile in the workspace header and the lists. Driven by
// the connection's iconSVG, which auth resolves on the server (automatic
// from the issuer, a library preset, or the uploaded SVG); without one, the
// admin's generic provider icon. Never derived from the provider's name.
//
// iconSVGDark (a single-colour library mark: Apple, Okta, OneLogin, Key,
// Building) is drawn instead in dark mode ([data-bs-theme="dark"], the
// page context's theme), so a black mark never vanishes on a dark tile.
export const ProviderLogo = ({ iconSVG, iconSVGDark }) => {
  const svg = iconSVG ? sanitizeIconSVG(iconSVG) : ''
  const dark = svg && iconSVGDark ? sanitizeIconSVG(iconSVGDark) : ''
  return (
    <div className={`sw-logo${dark ? ' sw-logo-has-dark' : ''}`} aria-hidden="true" data-testid="sw-logo">
      {svg
        ? <React.Fragment>
          <IconSVG svg={svg} className="sw-logo-svg sw-logo-light" />
          {dark && <IconSVG svg={dark} className="sw-logo-svg sw-logo-dark" />}
        </React.Fragment>
        : <IconProvider />}
    </div>
  )
}
